import { render } from "./ConcludeEvent.vue?vue&type=template&id=0948e398"
import script from "./ConcludeEvent.vue?vue&type=script&lang=js"
export * from "./ConcludeEvent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src973090976/src/remoterespects-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__